import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { TransferCaseCommonFunction } from 'app/outbox/transfer-functions';
import { SendCaseSettings } from '../inbox-data';

@Component({
  selector: 'app-ekomplet-settings',
  templateUrl: './ekomplet-settings.component.html'
})
export class EkompletSettingsComponent implements OnInit, OnChanges {
  @Input() data: SendCaseSettings;
  @Input() existingCustomer: string;
  @Output() update = new EventEmitter();
  f = new TransferCaseCommonFunction(this.http);

  loadingNumber = 0;
  loadingState = 'loading';

  standardSettings;
  companyUsers;
  responsibles;
  departments;
  dimensionCarrier;
  orderGroups;
  profitGroups;
  priceGroups;
  purposes;
  teamLeaders;

  constructor(private http: HttpClient, private sharedData: SharedDataService) { }

  ngOnInit(): void {
    this.sharedData.responsibles().subscribe((data) => { 
      this.responsibles = data; 
      //console.log(data) 
    });
    this.sharedData.eKompletSettings().subscribe((data) => { 
      this.standardSettings = data; 
      //console.log(data);
      this.reset();
    });
    this.getTypes();
  }

  ngOnChanges() {
    if (!!this.standardSettings) {
      setTimeout(() => {
        this.reset();
      }, 500);
    }
  }

  reset() {
    this.data = {
      ...new SendCaseSettings(),
      responsibleId: localStorage.getItem('bearer'),
      integrationId: '7e82cc3e-163e-4cb2-ba25-939fc339f021',
      caseId: this.data.caseId,
      eDimensionCarrierId: this.standardSettings.eDimensionCarrierId,
      eDimensionDepartmentId: this.standardSettings.eDimensionDepartmentId,
      eOrderGroupId: this.standardSettings.eOrderGroupId,
      ePriceGroupId: this.standardSettings.ePriceGroupId,
      eDimensionPurposeId: this.standardSettings.eDimensionPurposeId,
      eProfitGroupId: this.standardSettings.eprofitGroupId,
      eProjectType: this.standardSettings.eProjectType
    }
    //console.log(this.data);
  }
  
  getTypes() {
    this.loadingNumber = 0;
    // if (!this.companyUsers) {
    //   this.sharedData.companyUsers().subscribe({
    //     next: (data: any) => {
    //       console.log(data);
    //       if (!!data && data.length > 0) {
    //         this.companyUsers = data.filter(x => !!x.externalId).sort((a,b) => a.name < b.name ? -1 : 1);
    //         this.data.responsibleId = localStorage.getItem('bearer');
    //       }
    //       this.checkLoading();
    //     }, 
    //     error: (err) => { console.error(err); this.loadingState = 'error'; }
    //   });
    // } else {
    //   this.checkLoading();
    // }
    if (!this.departments) {
      this.f.eKompletDepartment().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.departments = data.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.dimensionCarrier) {
      this.f.eKompletDimensionCarrier().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.dimensionCarrier = data;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.orderGroups) {
      this.f.eKompletOrderGroup().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.orderGroups = data;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.profitGroups) {
      this.f.eKompletProfitGroup().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.profitGroups = data;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.priceGroups) {
      this.f.eKompletPriceGroup().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.priceGroups = data;
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    if (!this.purposes) {
      this.f.eKompletPurposes().subscribe({
        next: (data: any) => {
          //console.log(data);
          if (!!data && data.length > 0) {
            this.purposes = data.sort((a, b) => a.name < b.name ? -1 : 1);
          }
          this.checkLoading();
        }, 
        error: (err) => { console.error(err); this.loadingState = 'error'; }
      });
    } else {
      this.checkLoading();
    }
    // if (!this.teamLeaders) {
    //   this.f.eKompletTeamLeader().subscribe({
    //     next: (data: any) => {
    //       console.log(data);
    //       if (!!data && data.length > 0) {
    //         this.teamLeaders = data;
    //       }
    //       this.checkLoading();
    //     }, 
    //     error: (err) => { console.error(err); this.loadingState = 'error'; }
    //   });
    // } else {
    //   this.checkLoading();
    // }
  }

  checkLoading() {
    this.loadingNumber = this.loadingNumber + 1;
    //console.log(this.loadingNumber)
    if (this.loadingNumber == 6) {
      this.loadingState = 'done';
      this.updateParent();
    }
  }

  updateParent() {
    //console.log(this.data);
    this.update.emit(this.data);
  }

}
